const normolizeTweetsData = (data) => {
  return data.map((info) => ({
    link: info.node.link,
    avatar: info.node.avatar.file.url.substring(2),
    name: info.node.name,
    nick: info.node.nick,
    text: info.node.text.content[0].content[0].value,
    date: info.node.date,
    likes: info.node.likes,
  }));
};

export default normolizeTweetsData;
